import stocksJson from "./stocks.json";

/**
 * TradingView symbol ("NASDAQ:AAPL") to company name. The JSON is a flat map,
 * but callers look symbols up by computed key, so it is typed as a record
 * rather than by its 7000-odd literal keys.
 */
export const stocks: Record<string, string | undefined> = stocksJson;

export default stocks;
